import { gql, useMutation } from 'urql';
import type { CredentialsRecipient } from '../lib/parse-recipients';

export const SEND_CREDENTIALS = gql`
  mutation SendCredentials($input: SendCredentialsInput!) {
    sendCredentials(input: $input) {
      sent
      failed
      errors {
        email
        error
      }
    }
  }
`;

export interface SendCredentialsVars {
  input: {
    recipients: CredentialsRecipient[];
    subject: string;
    bodyHtml: string;
    testOnly: boolean;
  };
}

export interface SendCredentialsResponse {
  sendCredentials: {
    sent: number;
    failed: number;
    errors: { email: string; error: string }[];
  };
}

export const useSendCredentials = () => {
  const [{ fetching }, executeMutation] = useMutation<SendCredentialsResponse, SendCredentialsVars>(SEND_CREDENTIALS);

  return { fetching, sendCredentials: executeMutation };
};
